import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=6c70fe33&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=6c70fe33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70fe33",
  null
  
)

export default component.exports